// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchBidderBiddingAllParams = {
    authToken: string,
    deployment: string,
};

export const fetchBidderBiddingAll = ({ authToken, deployment }: FetchBidderBiddingAllParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: '<ITEM-API>bidder/bidding/all' });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type FetchBidderBiddingUpcomingParams = {
    authToken: string,
    deployment: string,
};

export const fetchBidderBiddingUpcoming = ({ authToken, deployment }: FetchBidderBiddingUpcomingParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: '<ITEM-API>bidder/bidding/upcoming' });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type FetchCatalogBiddingParams = {
    authToken: string,
    catalogId: number,
    deployment: string,
};

export const fetchCatalogBidding = ({ authToken, catalogId, deployment }: FetchCatalogBiddingParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            authToken,
            deployment,
            path: `<ITEM-API>spa/small/catalog/${catalogId}/bidding`,
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type FetchItemBiddingParams = {
    authToken: string,
    deployment: string,
    itemId: number,
};

export const fetchItemBidding = ({ authToken, deployment, itemId }: FetchItemBiddingParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: `<ITEM-API>spa/small/item/${itemId}/bidding` });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
